/* eslint-disable @typescript-eslint/no-explicit-any */
import { MutationDeleteReservePaymentArgs } from '../gql/graphql';
import { MutationHookOptions, useMutation } from '@apollo/client';
import { GET_RESERVES } from './reserves.query';
import { graphql } from '../gql';
import { GET_CLAIM } from './claim.query';

export const DELETE_RESERVE_PAYMENT = graphql(`
  mutation deleteReservePayment($reserveUuid: String!, $paymentUuid: String!) {
    deleteReservePayment(reserveUuid: $reserveUuid, paymentUuid: $paymentUuid) {
      uuid
    }
  }
`);

export function useDeleteReservePaymentMutation(
  options: MutationHookOptions<any, MutationDeleteReservePaymentArgs> = {}
) {
  const [deleteReservePayment, { loading, error, reset }] = useMutation(
    DELETE_RESERVE_PAYMENT,
    {
      refetchQueries: [GET_RESERVES, GET_CLAIM],
      ...options,
    }
  );

  return {
    deleteReservePayment,
    loading,
    error,
    reset,
  };
}
